import { mergeStyleSets } from '@fluentui/react';

const getStyles = (theme) =>
  mergeStyleSets({
    defaultInput: {
      width: '100%',
      borderRadius: '6px',
      border: `1px solid ${theme.palette.gray3}`,
      height: '48px',
      fontSize: '1.25rem',
      padding: '0 16px',
      boxSizing: 'border-box',
    },
    viewInput: {
      width: '100%',
      borderRadius: '6px',
      border: `1px solid ${theme.palette.gray3}`,
      height: '48px',
      fontSize: '1.25rem',
      padding: '0 16px',
      boxSizing: 'border-box',
    },
  });

export default getStyles;
